import { type ComponentProps, lazy, Suspense } from 'react';

import { ScreenLoadingIndicator } from '@pressreader/ui-controls';

const Lazy = lazy(async () => {
    const module = await import(/* webpackChunkName: "CopyArticleDialogWrapper" */ './wrapper');
    return { default: module.CopyArticleDialogWrapper };
});

export function CopyArticleDialogWrapperLazy(props: ComponentProps<typeof Lazy>) {
    return (
        <Suspense fallback={<ScreenLoadingIndicator />}>
            <Lazy {...props} />
        </Suspense>
    );
}
